export enum CONTENT_EDITOR {
    /**
     * @value Changing the contribution mode will redirect you to the corresponding editor. The content will be saved as draft before the redirection to keep all your changes.
     * @description The message of the confirm dialog displayed when switching to designer or writer mode in the content editor. It is necessary to explain to the user why its content will be saved.
     */
    CONFIRM_SWITCH_CONTRIBUTION_MODE_MESSAGE = 'CONTENT_EDITOR.CONFIRM_SWITCH_CONTRIBUTION_MODE_MESSAGE',
    /**
     * @value Switch to designer mode?
     * @description The title of the confirm dialog when switching from writer to designer mode in content editor.
     */
    CONFIRM_SWITCH_DESIGNER_MODE_TITLE = 'CONTENT_EDITOR.CONFIRM_SWITCH_DESIGNER_MODE_TITLE',
    /**
     * @value Switch to writer mode?
     * @description The title of the confirm dialog when switching from designer to writer mode in content editor.
     */
    CONFIRM_SWITCH_WRITER_MODE_TITLE = 'CONTENT_EDITOR.CONFIRM_SWITCH_WRITER_MODE_TITLE',
    /**
     * @value Content saved successfully
     */
    CONTENT_SAVE_SUCCESS = 'CONTENT_SAVE_SUCCESS',
    /**
     * @value CSS Class
     * @description Label of the input to add css classes to a content when editing a content's settings.
     */
    CONTENT_SETTINGS_CSS_CLASSES = 'CONTENT_EDITOR.CONTENT_SETTINGS_CSS_CLASSES',
    /**
     * @value Supports multiple classes separated by commas.Classes will be prefixed by 'app-content--module-'.
     * @description Helper of the input to add css class to a content, within the content settings.
     */
    CONTENT_SETTINGS_CSS_CLASSES_HELPER = 'CONTENT_EDITOR.CONTENT_SETTINGS_CSS_CLASSES_HELPER',
    /**
     * @value CSS Identifier
     * @description Label of the input to add an HTML ID on the content, when editing the content's settings.
     */
    CONTENT_SETTINGS_CSS_IDENTIFIER = 'CONTENT_EDITOR.CONTENT_SETTINGS_CSS_IDENTIFIER',
    /**
     * @value Editable by
     */
    CONTENT_SETTINGS_EDITABLE_BY = 'CONTENT_SETTINGS_EDITABLE_BY',
    /**
     * @value Users in these groups can edit and design this content.
     */
    CONTENT_SETTINGS_EDITORS_HELPER = 'CONTENT_EDITOR.CONTENT_SETTINGS_EDITORS_HELPER',
    /**
     * @value If specified, the content will point to this URL
     */
    CONTENT_SETTINGS_EXTERNAL_LINK_HELPER = 'CONTENT_SETTINGS_SLUG_HELP',
    /**
     * @value Featured content
     * @description The label of the checkbox to set a content as featured.
     */
    CONTENT_SETTINGS_FEATURED_CONTENT = 'CONTENT_EDITOR.CONTENT_SETTINGS_FEATURED_CONTENT',
    /**
     * @value When this setting is enabled, the piece of content is only displayed on widgets in which the "Featured-only" option is set. You can also set a start date and an end date to define its visibility time slot as featured.
     * @description The helper displayed on the checkbox to set a content as featured in content settings.
     */
    CONTENT_SETTINGS_FEATURED_CONTENT_HELPER = 'CONTENT_EDITOR.CONTENT_SETTINGS_FEATURED_CONTENT_HELPER',
    /**
     * @value Lets you highlight the piece of content for specific groups.
     * @description Helper of the group selector to select groups the content you are editing will be highlighted for
     */
    CONTENT_SETTINGS_HIGHLIGHTED_FOR_HELPER = 'CONTENT_EDITOR.CONTENT_SETTINGS_HIGHLIGHTED_FOR_HELPER',
    /**
     * @value Settings sections
     * @description The label that will be read by screen readers when arriving on the navigation within the content settings. This navigation element allows the user to navigate through the different sections of the content settings.
     */
    CONTENT_SETTINGS_NAVIGATION_LABEL = 'DESIGNER.CONTENT_SETTINGS_NAVIGATION_LABEL',
    /**
     * @value Group members can receive email, bell and push notifications based on their personal notification settings.
     * @description Helper of the input to select groups to notify when a content is published.
     */
    CONTENT_SETTINGS_NOTIFY_GROUPS_HELPER = 'CONTENT_EDITOR.CONTENT_SETTINGS_NOTIFY_GROUPS_HELPER',
    /**
     * @value Send notification to
     * @description Within the contents' settings, the label of the input allowing the user which groups will be notified on content publication
     */
    CONTENT_SETTINGS_NOTIFY_GROUPS_LABEL = 'CONTENT_EDITOR.CONTENT_SETTINGS_NOTIFY_GROUPS_LABEL',
    /**
     * @value Set this content as the site homepage. This setting overwrites any existing homepage.
     * @description Helper of the  checkbox that allows the user to set a content as the homepage within the content settings.
     */
    CONTENT_SETTINGS_SET_AS_HOMEPAGE_HELPER = 'CONTENT_EDITOR.CONTENT_SETTINGS_SET_AS_HOMEPAGE_HELPER',
    /**
     * @value This slug contains a restricted term.
     * @description Display a warning message in the "slug" input, in the content designer settings panel. This warning message is displayed when the content in the input match a list of restricted word. Meaning that the slug is not allowed because the word used is not allowed.
     */
    CONTENT_SETTINGS_SLUG_RESERVED_WORDS = 'CONTENT_EDITOR.CONTENT_SETTINGS_SLUG_RESERVED_WORDS',
    /**
     * @value A slug is the last part of a URL. Some terms can’t be used — %DOCUMENTATION_LINK%.
     * @description Input helper displayed in the content settings panel of the new content designer. Explain what is a "slug", the property to define in the input and display a link to the documentation that will give some informations on the restrictions in place.
     */
    CONTENT_SETTINGS_SLUG_RESTRICTIONS = 'CONTENT_EDITOR.CONTENT_SETTINGS_SLUG_RESTRICTIONS',
    /**
     * @value Select at least one Group or Space
     * @description "Space" should not be translated, it's a feature name.
     */
    CONTENT_SETTINGS_VISIBLE_BY_ERROR = 'CONTENT_SETTINGS.VISIBLE_BY_ERROR',
    /**
     * @value Ending day
     */
    FEATURED_DATE_ENDING_DAY = 'FRONT.EVENT.DIALOG.ENDING_DAY',
    /**
     * @value Ending hour
     */
    FEATURED_DATE_ENDING_HOUR = 'FRONT.EVENT.DIALOG.ENDING_HOUR',
    /**
     * @value Starting day
     */
    FEATURED_DATE_STARTING_DAY = 'FRONT.EVENT.DIALOG.STARTING_DAY',
    /**
     * @value Starting hour
     */
    FEATURED_DATE_STARTING_HOUR = 'FRONT.EVENT.DIALOG.STARTING_HOUR',
    /**
     * @value Url format is invalid
     */
    INVALID_SLUG = 'SLUG_BAD_FORMAT',
    /**
     * @value Url already exists on another page
     */
    URL_ALREADY_EXISTS_ERROR = 'SERVER_ERROR_URL_ALREADY_EXISTS',
}
